import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Select } from "antd";
import { connect } from "react-redux";

import "./SelectPrivacy.scss";

const Option = Select.Option;

class SelectPrivacy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      privacy: "",
      category: "",
      categories: [],
      elements: [],
    };
  }

  componentDidMount() {
    const {
      newChat,
      draft,
      contextList,
      messageVisibilityOptions,
      onCategoryChange,
    } = this.props;

    const chatConfig = window.Social.getChatConfig();
    const currentContext = contextList?.length === 1 && contextList[0];

    let categoryFromCurrentContext;

    if (currentContext) {
      const currentElement = currentContext.find(
        (elem) => elem.description === chatConfig.hashElementPrefix
      );

      if (currentElement?.content) {
        categoryFromCurrentContext = chatConfig.hashElementInQuotes
          ? `#"${currentElement.content}"`
          : `#${currentElement.content}`;
      }
    }

    let privacy = draft?.privacy || chatConfig.defaultPrivacy;

    let category =
      draft?.category ||
      categoryFromCurrentContext ||
      chatConfig.defaultCategory;

    let elements =
      draft?.elements || (categoryFromCurrentContext && currentContext) || [];

    if (newChat && currentContext && messageVisibilityOptions?.length) {
      privacy = messageVisibilityOptions[0];
      category = categoryFromCurrentContext || category;
      elements = currentContext || elements;
    }

    this.setState(
      {
        privacy,
        category,
        elements,
      },
      () => onCategoryChange(this.state)
    );

    let categories = [
      {
        name: chatConfig.defaultCategory,
        elements: [],
      },
    ];

    contextList?.forEach((context) => {
      const element = context.find(
        (elem) => elem.description === chatConfig.hashElementPrefix
      );

      if (!element) {
        return;
      }

      categories.push({
        name: chatConfig.hashElementInQuotes
          ? `#"${element.content}"`
          : `#${element.content}`,

        elements: context,
      });
    });

    this.setState({
      categories,
    });
  }

  componentDidUpdate(prevProps) {
    const chatConfig = window.Social.getChatConfig();

    if (this.props.contextList !== prevProps.contextList) {
      let categories = [
        {
          name: chatConfig.defaultCategory,
          elements: [],
        },
      ];

      this.props.contextList?.forEach((context) => {
        const element = context.find(
          (elem) => elem.description === chatConfig.hashElementPrefix
        );

        if (!element) {
          return;
        }

        categories.push({
          name: chatConfig.hashElementInQuotes
            ? `#"${element.content}"`
            : `#${element.content}`,

          elements: context,
        });
      });

      this.setState({
        categories,
      });
    }
  }

  onPrivacyChange(value) {
    this.setState(
      {
        privacy: value,
      },
      () => this.props.onCategoryChange(this.state)
    );
  }

  onCategoryChange(value, option) {
    const chatConfig = window.Social.getChatConfig();

    this.setState(
      {
        category: value,
        elements:
          (option.props.element &&
            option.props.element.elements &&
            option.props.element.elements) ||
          [],
      },
      () => this.props.onCategoryChange(this.state)
    );

    if (value === chatConfig.defaultCategory) {
      this.onPrivacyChange(chatConfig.defaultPrivacy);
    }
  }

  getCategoryOptions() {
    let children = [];

    for (let i = 0; i < this.state.categories.length; i++) {
      let category = this.state.categories[i];
      children.push(
        <Option
          key={i}
          title={category.name}
          value={category.name}
          element={category}
        >
          <span className="title">{category.name}</span>
          <span className="description">{category.alias}</span>
        </Option>
      );
    }

    return children;
  }

  getPrivacyOptions() {
    const { messageVisibilityOptions } = this.props || [];

    const privacyPolicy = window.Social.getPrivacyTypesConfig();

    return messageVisibilityOptions?.map((option) => {
      const privacy = privacyPolicy.find((privacy) => privacy.value === option);

      if (!privacy) {
        return;
      }

      const currentTitle = this.props.intl.formatMessage({
        id: privacy.title,
      });

      return (
        <Option key={privacy.value} value={privacy.value} title={currentTitle}>
          <span className="title">{currentTitle}</span>
          <span className="description">
            {this.props.intl.formatMessage({ id: privacy.description })}
          </span>
        </Option>
      );
    });
  }

  canSelectPrivacyType() {
    const chatConfig = window.Social.getChatConfig();

    if (!chatConfig.defaultCategoryPrivacyLock || this.props.disabled) {
      return false;
    }

    return (
      this.state.categories.length > 1 &&
      this.state.category !== chatConfig.defaultCategory
    );
  }

  canSelectCategory() {
    if (
      !window.Social.getChatConfig().defaultCategoryPrivacyLock ||
      this.props.disabled
    ) {
      return false;
    }

    return this.state.categories.length > 1;
  }

  render() {
    const canSelectPrivacyType = this.canSelectPrivacyType();
    const canSelectCategory = this.canSelectCategory();

    return (
      <div className="select-privacy">
        <div className="select-privacy-type-container">
          <Select
            value={this.state.privacy}
            className="select-privacy-type"
            dropdownStyle={{ paddingLeft: 5 }}
            optionLabelProp="title"
            dropdownMatchSelectWidth={false}
            dropdownClassName="select-privacy-type-dropdown"
            getPopupContainer={() => this.privacyRef}
            disabled={!canSelectPrivacyType}
            showArrow={canSelectPrivacyType}
            onSelect={this.onPrivacyChange.bind(this)}
          >
            {this.getPrivacyOptions()}
          </Select>

          <div
            className="dropdown-container"
            ref={(node) => (this.privacyRef = node)}
          ></div>
        </div>

        <div className="select-category-container">
          <Select
            value={this.state.category}
            className="select-category"
            optionFilterProp="children"
            optionLabelProp="title"
            dropdownClassName="select-categories-dropdown"
            getPopupContainer={() => this.categoryRef}
            disabled={!canSelectCategory}
            showArrow={canSelectCategory}
            showSearch
            onSelect={this.onCategoryChange.bind(this)}
          >
            {this.getCategoryOptions()}
          </Select>

          <div
            className="dropdown-container"
            ref={(node) => (this.categoryRef = node)}
          ></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ Api, GeneralSettings }) => {
  return {
    dynamicMessageFilter: GeneralSettings.dynamicMessageFilter,
    contextList: Api.contextList,
  };
};

export default connect(mapStateToProps)(injectIntl(SelectPrivacy));
